interface AdminProfile {
    firstName: string;
    lastName: string;
    avatar?: string;
}

export enum AdminPermission {
    support = 'support',
}

export interface Admin {
    id: string;
    email: string;
    phoneNumber?: string;
    profile: AdminProfile;
    followers?: {
        organizationIds: string;
    };
    isAdmin: true;
    createdDate: string;
    updatedDate?: string;
    sevenDigitalExpiresAt: Date;
    adminPermissions?: AdminPermission[];
}

export interface CreateAdminPayload {
    email: string;
    profile: AdminProfile;
    initialPassword: string;
    adminPermissions?: AdminPermission[];
}
